import styled from 'styled-components'

import rem from '../../../styles/tools/rem'
import em from '../../../styles/tools/em'

import { txt16OpenSansBold, title16Galano } from '../../../styles/settings/types'

import { darkSlateBlue } from '../../../styles/settings/colors'

export const Title = styled.h1`
  letter-spacing: ${em('0.4px')};
  color: ${darkSlateBlue};
  ${title16Galano};
  letter-spacing: normal;
  line-height: 1;
  margin-left: 15px;
  margin-top: ${rem('8px')};
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 30px;
  margin-top: ${rem('20px')};
`

export const Container = styled.section`
  width: 100%;
  padding: ${rem('9px')} 0 ${rem('50px')};
  background-color: white;
  display: flex;
  justify-content: center;
`

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: ${rem('940px')};
  align-items: flex-start;
`

export const FilterContainer = styled.div`
  padding: 0;
`

export const ListItem = styled.li`
  margin: 0;
  height: 100%;
`
export const CheckBoxContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
`

export const FilterTypes = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  height: ${rem('45px')};
  padding: 0;
  width: 100%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 0px 1px rgba(0, 0, 0, 0.12);
  border-radius: ${rem('8px')};
  overflow: auto;
  & li:last-of-type label {
    border: none;
  }
`

export const CheckboxLabel = styled.label`
  position: relative;
  color: ${darkSlateBlue};
  ${txt16OpenSansBold};
  padding: ${rem('10px')} ${rem('30px')};
  height: 100%;
  border-right: 1px solid rgba(17, 14, 73, 0.16);
`

export const InputCheckbox = styled.input.attrs({
  type: 'checkbox'
})`
  opacity: 0;
  display: block;
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  &:checked + ${CheckboxLabel} {
    background: #aeabc4;
  }
`



// WEBPACK FOOTER //
// ./src/app/modules/FilterByWeekDays/styles.js